import React from 'react';
import SmartDialog from "../SmartDialog";
import {Field, Form, Formik} from "formik";
import FormInput from "../FormInput";
import {Button, FormGroup} from "reactstrap";
import TTLProxy from "../../common/TTLAsyncProxy";
import {WalletEndpoints} from "../../common/ProxyEndpoints";
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import MDSpinner from 'react-md-spinner';
import HTML from '../../common/HtmlHelpers';
import Utils from "../../common/Utils";
import Providers from './Providers';
import _ from 'lodash';

class AddWalletDialog extends React.Component {

    static propTypes = {
        onCreateWallet: PropTypes.func
    };

    constructor(props){
        super(props);
        this.onCreateWallet = this.onCreateWallet.bind(this);
        this.proxy =  TTLProxy.getInstance();

        //
        const initialProvider = Providers[0];
        this.state = this.getStateUpdate(initialProvider.provider,{
            initialValues: {
                name: '',
                is_default: false,
                provider: {
                    label: initialProvider.name,
                    value: initialProvider.provider
                }
            },
            user: null
        });
    }

    async onCreateWallet(values){

        const { user } = this.state;
        const proxy = this.proxy;

        try{

            const { name , value , provider,  is_default } = values;
            const providerInstance = Providers.find(x => x.provider === provider.value);

            const res = await proxy.processRequest(WalletEndpoints.createWallet({
                name,
                value,
                is_default,
                provider: provider.value,
                meta: providerInstance.getMeta(values)
            }, user ? user.id : undefined));

            if(res.ok){

                //  toast
                HTML.toastSuccess('Wallet created successfully');

                if(this.props.onCreateWallet){
                    this.props.onCreateWallet(res.getPayload());
                }

                this._dlg.hide();
            }

        }
        catch (e) {

            //  toast error
            HTML.toastError(Utils.getResponseError(e));

        }

    }

    show(user = null) {

        this.setState({
            user
        }, () => this._dlg.show());
    }


    getStateUpdate(provider,state){

        const providerInstance = Providers.find(x => x.provider === provider);

        return {
            ...state,
            validationSchema: Yup.object().shape({
                name: Yup.string().required().max(32).label("Wallet Name"),
                provider: Yup.string().required().label("Provider"),
                ... providerInstance.validationSchema
            }),

            initialValues: {
                ...state.initialValues,
                ...providerInstance.initialValues
            }
        }

    }


    render() {

        return <SmartDialog title={"Add Wallet"} ref={r => this._dlg = r}>

            <Formik onSubmit={async (values,{ setSubmitting }) => {

                        try{
                            await this.onCreateWallet(values);
                        }catch (e) {

                        }
                        finally {
                            setSubmitting(false);
                        }

                    }}
                    validate={values => {

                        let errors;
                        const provider = values.provider.value;
                        const providerInstance = Providers.find(x => x.provider === provider);
                        if(providerInstance && _.isFunction(providerInstance.customValidation)){
                            errors = providerInstance.customValidation(values);
                        }

                        return errors;
                    }}
                    enableReinitialize
                    ref={r => this._form = r}
                    validationSchema={this.state.validationSchema}
                    initialValues={this.state.initialValues}>

                {(context) => {

                    const provider = context.values.provider.value;
                    const providerInstance = Providers.find(x => x.provider === provider);
                    const ProviderComponent = providerInstance ? providerInstance.component : null;

                    return <Form>

                        <FormInput name={"name"}
                                   title={"Wallet Name"}
                                   placeholder={"Enter name for wallet..."}
                                   type={"text"}/>

                        <FormInput name={"provider"}
                                   title={"Payment Provider"}
                                   placeholder="Select payment provider..."
                                   type={"dropdown"}
                                   onChange={({value}) => {
                                       this.setState(state => this.getStateUpdate(value,state));
                                   }}
                                   items={Providers.map(x => ({  text: x.name , value: x.provider }))}/>

                        {providerInstance && <React.Fragment>
                            <hr/>
                            <ProviderComponent {...context}/>
                        </React.Fragment>}

                        <FormGroup>
                            <label>Set as default wallet: <Field name={"is_default"} render={({ field , form: { setFieldValue,  values } }) => {

                                return <input type={"checkbox"}
                                              {...field}
                                              onChange={() =>{
                                    setFieldValue("is_default",!values.is_default);
                                }}/>

                            }}/></label>
                        </FormGroup>


                        <hr/>

                        <div className="clearfix">

                            <div className="pull-left">
                                {context.isSubmitting && <MDSpinner  size={32}/>}
                            </div>

                            <div className="pull-right">
                                <Button color="green" disabled={context.isSubmitting}><i className="fa fa-check"/> Create Wallet</Button>
                            </div>

                        </div>
                    </Form>
                }}
            </Formik>

        </SmartDialog>

    }
}

export default AddWalletDialog;


// WEBPACK FOOTER //
// ./src/components/WalletManagement/AddWalletDialog.js